module.exports = __webpack_public_path__ + "da360a6878714e797cbb149ff6738b13.svg";